module.exports = "https://static.im-cdn.com/mjc/storefront/Simplar/static/media/InviteBanner.67a433ae.jpg";